import { useTranslation } from 'react-i18next'
import { useAuth } from '../../hooks/useAuth'
import { Button } from '../ui/Button'

interface HeaderProps {
  onMenuClick: () => void
}

export function Header({ onMenuClick }: HeaderProps) {
  const { user, signOut } = useAuth()
  const { t } = useTranslation()

  return (
    <header className="flex h-16 items-center justify-between border-b border-gray-200 bg-white px-4 sm:px-6">
      {/* Hamburger — mobile only */}
      <button onClick={onMenuClick} className="rounded-lg p-2 text-gray-600 hover:bg-gray-100 md:hidden" aria-label="Open menu">
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      {/* Spacer for desktop */}
      <div className="hidden md:block" />

      <div className="flex items-center gap-2 sm:gap-4">
        <span className="hidden text-sm text-gray-600 sm:inline">{user?.email}</span>
        <Button variant="ghost" size="sm" onClick={signOut}>
          {t('actions.signOut')}
        </Button>
      </div>
    </header>
  )
}
